import Base from './Base'

class AuthService extends Base {
  login(data) {
    return this.post('account/login', data)
  }

  logout() {
    return this.post('account/logout')
  }

  queryOriginCompany(data) {
    return this.post('company/query_user_original_company', data)
  }

  saveCompany(data) {
    return this.post('company/save_company', data)
  }

  saveEditor(data) {
    return this.post('company/save_editor', data)
  }

  queryUser(data) {
    return this.post('account/query_user', data)
  }

  queryGroup(data) {
    return this.post('account/query_group', data)
  }

  activate(data) {
    return this.post('account/activate_user', data)
  }

  updateGroupUser(data) {
    return this.post('account/update_group_user', data)
  }

  getUserInfo() {
    return this.post('account/get_user_info')
  }

  updateUserInfo(postData) {
    return this.post('account/update_user_info', postData)
  }

  loginEmail(data) {
    return this.post('account/login_mail', data)
  }

  sendCode(data) {
    return this.post('account/send_code', data)
  }

  verifyCode(data) {
    return this.post('account/verify_code', data)
  }

  verifyPhone(data) {
    return this.post('account/verify_phone', data)
  }

  loginPhone(data) {
    return this.post('account/login_phone', data)
  }

  registerCallback(data) {
    return this.post('account/register_success', data)
  }

  resetPassword(data) {
    return this.post('account/reset_password', data)
  }

  register(data) {
    return this.post('account/register', data)
  }

  forgetPassword(data) {
    return this.post('account/forget_password', data)
  }

  resetUserRole() {
    return this.post('account/reset_user_role')
  }

  saveSinger(data) {
    return this.post('ai_singer/save_singer', data)
  }

  loginByCode(data) {
    return this.post('account/scan_code_login', data)
  }

  getQQMusicQrCode() {
    return this.post('account/get_qq_music_qr_code')
  }

  pollQQMusicQrCodeResult(data) {
    return this.post('account/poll_qq_music_qr_code_result', data)
  }

  bindQQMusicAccount(data) {
    return this.post('account/bind_qq_music', data)
  }

  bindKGAccount(data) {
    return this.post('account/bind_kg', data)
  }

  bindPhoneNum(data) {
    return this.post('account/bind_phone_num', data)
  }
}

export default new AuthService()
